import { useMutation, useQueryClient } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { PUT_URL } from '@utils/api/endpoints.ts';
import { DocumentMutationIdentifier } from '@utils/types/editors/transcripts/api.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';
import { BaseError } from '@utils/types/shared/base.ts';

export function useSharedDocumentFinished() {
  const queryClient = useQueryClient();
  const { t } = useTranslation();

  const extractTokenFromUrl = () => {
    const url = window.location.href;
    return url.split('/').pop();
  };

  return useMutation<void, AxiosError<BaseError>, DocumentMutationIdentifier>(
    async ({ sessionId, documentId }) => {
      const token = extractTokenFromUrl();
      if (!token) throw new Error(t('token-not-found-in-url'));

      const finishUrl = `${PUT_URL(sessionId, documentId).finishSharedSessionDocument}?token=${token}`;
      await Axios.put(finishUrl);
    },
    {
      onSuccess: async (_, request) => {
        await queryClient.invalidateQueries(
          QueryKeys.document(request.sessionId, request.documentId)
        );
        await queryClient.invalidateQueries(
          QueryKeys.session(request.sessionId)
        );
      }
    }
  );
}
